import { useEffect, useState } from "react";
import { useListManager } from "../../../contexts/list.manager";
import { useLocation, useNavigate } from "react-router-dom";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import { TbCategory, TbRosetteDiscount } from "react-icons/tb";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import { BsToggles, BsToggles2 } from "react-icons/bs";
import { MdBlock, MdOutlineCategory } from "react-icons/md";

export function LicenseBlocked({ ...props }) {
   const { lineSelected } = useListManager();
   const [searchText, setSearchText] = useState("");
   const [filters, setFilters] = useState("");
   const navigate = useNavigate();
   const location = useLocation();
   const [refreshKey, setRefreshKey] = useState(0);

   useEffect(() => {
      if (location.state?.deletedId) {
         setRefreshKey((k) => k + 1);
         navigate(location.pathname, { replace: true, state: {} });
      }
   }, [location.state, navigate, location.pathname]);

   return (
      <div className="consulta-container">
         <div className="search-list-wrapper">
            <SearchContainer
               icon={<MdBlock size={20} />}
               title="Licenças bloqueadas"
               description="Buscar"
               hideAddButton={true}
            >
               <SearchInput
                  value={searchText}
                  placeholder="Buscar"
                  onChange={({ target }) => setSearchText(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
               />
            </SearchContainer>
            <Container>
               {/* <ListClientsLicence filters={filters} refreshKey={refreshKey} /> */}
               <p className="text-xl! opacity-40">Página em construção</p>
            </Container>
         </div>
         <ConsultaFormContainer>
            {/* <FormClientsLicence licenca={lineSelected} type="consulta" /> */}
         </ConsultaFormContainer>
      </div>
   );
}